var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditorNodeWrapper',{class:[
    'node-container',
    'link-container',
    _vm.blockWidthClass,
    {
      'parent-first-child': _vm.parentFirstChild,
      'parent-last-child': _vm.parentLastChild,
    } ],on:{"observe-node-visibility":function($event){return _vm.$emit('observe-node-visibility', Object.assign({}, $event, {nodeId: _vm.node.id}))}}},[_c('ThemedButton',{class:['open-link-btn', _vm.node.align.toLowerCase()],attrs:{"data-external":"view-link-button","theme":_vm.theme},on:{"click":_vm.handleClick}},[_c('ProsemirrorViewerInput',{staticClass:"open-link-btn-text",attrs:{"content":_vm.node.content}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }